<template>
    <!-- eslint-disable max-len -->
    <div class="game-list-container">
        <div
            v-if="!noHeader"
            class="game-list-header"
            :style="headerStyle"
        >
            <h5 v-if="header"
                style="
                    margin: 0;
                    width: 100%;
                "
                v-html="header"
            ></h5>
        </div>
        <div class="game-scroll-container">
            <div class="game-scroll">
                <class-box
                    style="margin: 0 0 45px 60px;"
                    v-for="(entry, idx) in list"
                    :key="idx"
                    :entry="entry"
                    @play-clicked="(e) => $emit('play-clicked', e)"
                    @reset-clicked="(e) => $emit('reset-clicked', e)"
                    @details-clicked="(e) => $emit('details-clicked', e)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import ClassBox from './GameHubClassBox';

export default {
  components: { ClassBox },
  props: {
    list: { type: Array, required: true },
    noHeader: { type: Boolean, default: false },
    headerStyle: { type: Object, default: null },
    header: { type: String, default: null }
  }
};
</script>

<style lang="scss" scoped>
.game-list-container
{
    background-color: rgba(17, 17, 17, 0);
}

.game-list-header
{
    background-size: cover;
    background-color: var(--hubSubheaderBackgroundColor);
    color: var(--hubSubheaderTextColor);
    width: 100%;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
    overflow: hidden;

    display: flex;
    align-items: center;
}

.game-scroll-container
{
    width: 100%;
    max-width: 100%;
    padding: 10px;
}

.game-scroll
{
    display: flex;
    flex-flow: row wrap;
    overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/game/pages/components/GameHubClassList.vue